import { render, staticRenderFns } from "./UpcomingEventsWidget.vue?vue&type=template&id=2e466a24&scoped=true&"
import script from "./UpcomingEventsWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventsWidget.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventsWidget.vue?vue&type=style&index=0&id=2e466a24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e466a24",
  null
  
)

export default component.exports